export const teachingData = {
  teachingHeaders: [
    { heading: "Teaching Enagements" },
    {
      columns: [
        "S.No.",
        "Course Name",
        "Course Code",
        "Semester & Year",
        "Class",
      ],
    },
  ],
  teachingDetails: [
    {
      "S.No.": "1",
      "Course Name": "Channel Hydraulics",
      "Course Code": "CEN-205",
      "Semester & Year": "Autum Sem 2023-24",
      Class: "B.Tech",
    },
    {
      "S.No.": "2",
      "Course Name": "Advanced Hydrology",
      "Course Code": "CEN-531",
      "Semester & Year": "Autum Sem 2023-24",
      Class: "M.Tech",
    },
  ],
};
export const specialLacturesData = {
  specialLacturesHeaders: [
    { heading: "Special Lactures Delivered" },
    {
      columns: ["S.No.", "Title", "Organisation", "Date"],
    },
  ],
  specialLacturesDetails: [
    {
      "S.No.": "1",
      Title:
        "Exploring linkages amongst environmental challenges, science, and people participation for climate action",
      Organisation:
        "Faculty Development Program, Amity Institute of Environmental Sciences (AIES), Noida",
      Date: "7-Jun-2023",
    },
    {
      "S.No.": "2",
      Title: "Anthropogenic Impacts on Water Storage Dynamics across Scales",
      Organisation: `International conference on "Sustainable Development and Disaster Resilience Through Innovation (ICSDDRTI-2023)" at Amity University, Lucknow`,
      Date: "06-Oct-2023",
    },
  ],
};
